import Vue from 'vue';
import { defaultState } from './state';

export default {
  /**
   * Store global state
   */
  storeGlobalState(state, payload) {
    const property = Object.keys(payload)[0];
    const value = Object.values(payload)[0];

    if (state.hasOwnProperty(property)) {
      Vue.set(state, property, value);
    }
  },

  /**
   * Reset state to default state
   */
  resetState(state) {
    Object.assign(state, defaultState());
  },
  
  resetValidationErrors(state) {
    Vue.set(state, 'validationErrors', {});
  },

  clearValidationError(state, key) {
    const err = Object.assign({}, state.validationErrors);

    delete err[key];

    Vue.set(state, 'validationErrors', err);
  }
};
